import { I18nProvider as AriaI18nProvider } from '@react-aria/i18n';
import type { ReactNode } from 'react';

export type Locales =
  | 'en-US'
  | 'zh-CN'
  | 'zh-TW'
  | 'fr-CA'
  | 'fr-FR'
  | 'de-DE'
  | 'it-IT'
  | 'ja-JP'
  | 'pt-BR'
  | 'pt-PT'
  | 'ru-RU'
  | 'es-419'
  | 'es-ES'
  | 'ro-RO'
  | 'hu-HU'
  | 'el-GR'
  | 'ms-MY'
  | 'ar-AE'
  | 'ar-XM'
  | 'he-IL';

export type I18nProviderProps = {
  children: ReactNode;
  locale?: Locales;
};

export const I18nProvider = ({ children, locale }: I18nProviderProps) => {
  return <AriaI18nProvider locale={locale}>{children}</AriaI18nProvider>;
};
